import { manageCookies } from "@/business/shared/session/infrastructure/utils/manageCookies";
import { UserAuth, LoginActions } from "@/business/auth/domain/login";

export const loadDataMemoryService = {
  async execute(): Promise<{
    user: UserAuth | null;
  }> {
    const userMemory: Promise<UserAuth | null> = this.user();

    const [user] = (await Promise.all([userMemory])) as [UserAuth | null];

    return {
      user,
    };
  },

  async user(): Promise<UserAuth | null> {
    const memoryUser = manageCookies.get("userAuth");

    if (memoryUser === null) return null;

    const parseResponse = JSON.parse(memoryUser);

    return LoginActions().createUserAuth(
      parseResponse.username,
      parseResponse.token,
      parseResponse.role
    );
  },
};
